

import { useState, useEffect } from 'react';
//import CommentBox from '../../../components/CommentBox/CommentBox';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import axios from 'axios';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Rahu.scss';
import MuhuratLink from '../../../components/MuhuratLink/MuhuratLink';
import { Link } from 'react-router-dom';
import city from '../../../city.json'

const Rahu = () => {

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  

  const [currentDate, setCurrentDate] = useState(new Date());
  const [location, setLocation] = useState("Kolkata");
  const [timeFormat, setTimeFormat] = useState("12"); // "12", "24", or "24Plus"
 const [rahuKalam, setRahuKalam] = useState(null);


       // Temporary states for user input for submit button
const [tempDate, setTempDate] = useState(currentDate);
const [tempLocation, setTempLocation] = useState("Kolkata");
const [suggestions, setSuggestions] = useState([]);


  useEffect(() => {
    const fetchRahuKalam = async () => {

      const formattedDate = currentDate.toISOString().split('T')[0];

      if (!location || location.trim() === '') return;
      try {
        const res = await axios.get(`https://core-c343.onrender.com/api/panchanga?date=${formattedDate}&location=${location}`);
        
        // Safely extract rahuKalam
        if (res.data && res.data.rahuKalam) {
          setRahuKalam(res.data.rahuKalam);
        } else {
          console.error("Rahu Kalam data not found in response");
        }

      } catch (err) {
        console.error("Failed to fetch Rahu Kalam:", err);
      }
    };

    fetchRahuKalam();
  }, [currentDate, location]);

  const handlePrevDay = () => {
    const prev = new Date(currentDate);
    prev.setDate(prev.getDate() - 1);
    setCurrentDate(prev);
  };

  const handleNextDay = () => {
    const next = new Date(currentDate);
    next.setDate(next.getDate() + 1);
    setCurrentDate(next);
  };

  const handleDateInput = (e) => {
    setTempDate(new Date(e.target.value));
  };

const handleMonthClick = (monthIndex) => {
  const newDate = new Date(tempDate);
  newDate.setMonth(monthIndex);
  setTempDate(newDate);
};

const handleDayClick = (day) => {
  const newDate = new Date(tempDate);
  newDate.setDate(day);
  setTempDate(newDate);
};

const handleSubmit = () => {
  setCurrentDate(tempDate);
  setLocation(tempLocation);
};

  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };

// const formatTime = (time, mode) => {
//   if (!time || typeof time !== 'string') return "N/A";

//   const [start, end] = time.split(" to ");

//   const parseTime = (t) => {
//     if (!t) return "N/A";
//     const [hourMin, ampm] = t.trim().split(' ');
//     let [hour, minute] = hourMin.split(':').map(Number);
//     const isPM = ampm?.toLowerCase() === 'pm';

//     if (mode === '12') {
//       const suffix = isPM ? 'PM' : 'AM';
//       hour = hour % 12 || 12;
//       return `${hour}:${minute.toString().padStart(2, '0')} ${suffix}`;
//     }

//     if (mode === '24') {
//       return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
//     }

//     if (mode === '24Plus') {
//       if (isPM && hour < 12) hour += 12;
//       if (!isPM && hour === 12) hour = 0;
//       return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
//     }

//     return t;
//   };

//   return `${parseTime(start)} to ${parseTime(end)}`;
// };

  const formattedDate = currentDate.toISOString().split("T")[0];
  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });

  const calculateDuration = (start, end) => {
  const [sH, sM] = start.split(/:| /).map(Number);
  const [eH, eM] = end.split(/:| /).map(Number);
  let duration = (eH * 60 + eM) - (sH * 60 + sM);
  const hr = Math.floor(duration / 60);
  const min = duration % 60;
  return `${hr} hr ${min} min`;
};



function convertUtcToIstTimeOnly(utcTimeStr, mode = '12') {
  if (!utcTimeStr) return 'N/A';

  const [time, modifier] = utcTimeStr.trim().split(' ');
  let [hours, minutes] = time.split(':').map(Number);

  if (modifier.toUpperCase() === 'PM' && hours !== 12) hours += 12;
  if (modifier.toUpperCase() === 'AM' && hours === 12) hours = 0;

  const today = new Date();
  const date = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate(), hours, minutes));

  const options = {
    timeZone: 'Asia/Kolkata',
    hour: '2-digit',
    minute: '2-digit',
    hour12: mode === '12',
  };

  return date.toLocaleTimeString('en-IN', options);
}





const formatTime = (timeStr, mode = "12") => {
  if (!timeStr || typeof timeStr !== "string") return "N/A";

  const [hour, minute, second] = timeStr.split(":").map(Number);

  if (mode === "12") {
    const suffix = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;
    return `${hour12.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")} ${suffix}`;
  }

  if (mode === "24") {
    return `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")}`;
  }

  if (mode === "24+") {
    return `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")}:${second.toString().padStart(2, "0")}`;
  }

  return timeStr;
};

  return (
    <div className="rahu-container">
      <InnerNav />
      <div className="rahu-content">
        <Zodiac />
        <div className="rahu-details">
                <div className="title">Rahu kaal Muhurat</div>
                {/* <div className="sub">Running Do Ghati Muhurat</div> */}
              <div className="header">
                <div className="img-details">
                  <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRW3C3Ty79k_gyPc3OD5oWmoWQk5nXn1bGIYQ&s" alt="err" />
                  <div className="right">
                    <p>Rahu Kaal Timing</p>
                   
                  </div>
                </div>
                <div className="date-display">
                  <span className="day">{currentDate.getDate()}</span>
                  <span className="month">{readableDate}</span>
                </div>
              </div>

              <div className="controls">
                <div className="mode-toggle">
                  <button onClick={() => setTimeFormat("12")} className={timeFormat === "12" ? "active" : ""}>12 Hour</button>
                  <button onClick={() => setTimeFormat("24")} className={timeFormat === "24" ? "active" : ""}>24 Hour</button>
                  <button onClick={() => setTimeFormat("24Plus")} className={timeFormat === "24Plus" ? "active" : ""}>24 Plus</button>
                </div>

                <div className="month-grid">
                  {months.map((month, i) => (
                    <button key={i} onClick={() => handleMonthClick(i)}>{month}</button>
                  ))}
                </div>

                <div className="day-grid">
                  {Array.from({ length: 31 }, (_, i) => (
                    <button key={i} onClick={() => handleDayClick(i + 1)}>{i + 1}</button>
                  ))}
                </div>

                 <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  <input
                    type="date"
                    value={tempDate.toISOString().split("T")[0]}
                    onChange={handleDateInput}
                  />
                  <button onClick={handlePrevDay}>Prev Day</button>
                  <button onClick={handleNextDay}>Next Day</button>
                  <button onClick={handleSubmit}>Submit</button>

                </div>
              </div>

              <div className="muhurta-section">
                <div className="muhurta-header">
                  <div className="muhurta-date">{readableDate}, {weekDay}</div>
                </div>


                  {rahuKalam ? (
                      <div className="rahu-card">
                        <div className="rahu-header">
                          <h3>Rahu Kaal Timing</h3>
                          <p>{readableDate}</p> {/* If you still want to show today's date */}
                        </div>
                        <div className="rahu-img">
                          <img
                            src="https://images.tv9hindi.com/wp-content/uploads/2024/11/what-should-we-avoid-during-rahu-kaal.jpg"
                            alt="rahu"
                          />
                        </div>
                        <div className="rahu-data">
                          <h3>{formatTime(rahuKalam.start, timeFormat)} to {formatTime(rahuKalam.end, timeFormat)}</h3>
                          {/* <p>Duration: {calculateDuration(rahuKalam.start, rahuKalam.end)}</p> */}

                        </div>
                      </div>
                    ) : (
                      <p>No Rahu Kaal data available for today.</p>
                    )}

              </div>
            </div>

                   <section className="rahu-wrapper">
      <h1 className="rahu-title">About Rahu Kaal</h1>
      <div className="rahu-texts">
        <p>
          According to Vedic astrology Rahu is an inauspicious planet. During transition of planets the time under the influence of Rahu should be avoided to do any auspicious work. Doing Puja, Hawan or Yagya (यज्ञ) to propitiate auspicious planets during this time is interfered by Rahu due to its malefic nature. If one does Puja, Hawan or Yagya during Rahu Kaal then desired results are not achieved. Hence it is important to consider Rahu Kaal before starting any new work. By doing so, possibility of achieving desired results is increased.
        </p>

        <p>
          However any work related to Rahu gives good results during this period. Hawan, Yagya, etc. to propitiate Rahu can be done during this time.
        </p>

        <p>
          People, especially in South India, give utmost importance to Rahu Kaal. Auspicious activities like marriage rituals, engagement, 
          
          <Link to="/muhurat/griha-pravesh" 
            style={{textDecoration: 'underline', color: 'red', fontStyle: 'italic', marginLeft: '10px'}}>
           Griha Pravesh
          </Link>
          , any purchase of stocks, shares, gold, home, car and starting new business or trade are avoided during this time. Rahu Kaal is considered only for undertaking any new work and already started work can be continued during Rahu Kaal.
        </p>

        <p>
          Rahu Kaal, which is also spelled as Rahu Kala, Rahu Kal, Rahu Kalam and Rahu Kalaam, is a certain amount of time every day which lasts approximately for one and half hour. Rahu Kaal is one of the eight segments of the day between sunrise and sunset. Eight segments of the day are calculated by taking the total time between sunrise and sunset at a given place and then dividing this time duration by eight.
        </p>

        <p>
          Rahu Kaal timings and duration are not same for any two locations due to difference in local timings of sunrise and sunset. Even for one location Rahu Kaal timing and duration are not same for all days as sunrise and sunset timings keep changing throughout the year. In other words Rahu Kaal varies from place to place and from day to day. Hence Rahu Kaal should be looked at for each day.
        </p>

        <p>
          After sunrise first period (out of eight division of time between sunrise and sunset) which approximately lasts for one and half hour is always auspicious as this duration of the day is always free from malefic effects of Rahu. On Monday Rahu Kaal falls on the 2nd period, Saturday on the 3rd period, Friday on the 4th period, Wednesday on the 5th period, Thursday on the 6th period, Tuesday on the 7th period and Sunday on the 8th period.
        </p>

        <p>
          Few people consider Rahu Kaal for night duration also which is less popular as most important and auspicious work are started during day time. However Rahu Kaal during night can also be calculated by dividing duration between sunset and next day sunrise by eight. According to some Rahu Kaal on Tuesday, Friday and Sunday has more malefic effects than those of other weekdays.
        </p>
      </div>
    </section>
            
        <MuhuratLink/>
        {/* <CommentBox/> */}
      </div>
      <Footer />
    </div>
  );
};

export default Rahu;
